import { useToast } from "@chakra-ui/react";
import { ShowErrorNotFound } from "components/Toast/Index";
import { addDays } from "date-fns";
import { format } from "date-fns-tz";
import { pt } from "date-fns/locale";
import { formatDateUs } from "helpers/formated";
import { parseScheduleDrawer } from "helpers/Grid/ScheduleDrawerParse";
import { ITableHeader } from "Interfaces/Components/TableGrid";
import { IScheduleContext } from "Interfaces/Providers/Schedule";
import fileDownload from "js-file-download";
import { createContext, ReactNode, useCallback, useState } from "react";
import inventory from "services/inventory";
import schedule from "services/schedule";
import Swal from "sweetalert2";
import { useImmer } from "use-immer";
import ScheduleDrawerHeader from "variables/Header/ScheduleDrawer";

interface Auth0ProviderProps {
  children: ReactNode;
}

const ScheduleProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [loadingFerragem, setLoadingFerragem] = useState(false);
  const [loadingChaparia, setLoadingChaparia] = useState(false);
  const [loadingDrawer, setLoadingDrawer] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [isFirstData, setFirstData] = useState(true);

  const [filename, setFilename] = useState("Calendario");
  const [dateFerragem, setDateFerragem] = useState("");
  const [dateChaparia, setDateChaparia] = useState("");

  const [dataFerragem, updateDataFerragem] = useImmer<any[]>([]);
  const [dataChaparia, updateDataChaparia] = useImmer<any[]>([]);
  const [scheduleSelect, setScheduleSelect] = useImmer<any[]>([]);
  const [datesAvaliable, updateDateAvaliable] = useImmer<any[]>([]);
  const [datesSchedulesModify, updateDatesSchedulesModify] = useImmer<any[]>(
    []
  );
  const [idSelectDate, setSelectIdDate] = useState(0);
  const [headers] = useImmer<ITableHeader[]>(ScheduleDrawerHeader);
  const getDataChaparia = useCallback(
    async (start: any, end: any, supplierIds: number[] = []): Promise<any[]> => {
      setLoadingChaparia(true);
      setFirstData(false);
      setDateChaparia(start);

      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      return schedule
        .getScheduleCalendarV2(valueStore?.value, "CHAPARIA", supplierIds, start, end)
        .then((response) => {
          const data = response.data?.data || [];
          updateDataChaparia(data);
          setLoadingChaparia(false);
          return data;
        })
        .catch(() => {
          setLoadingChaparia(false);
          return [];
        });
    },
    [updateDataChaparia]
  );

  const getDataFerragem = useCallback(
    async (start: any, end: any, supplierIds: number[] = []): Promise<any[]> => {
      setLoadingFerragem(true);
      setFirstData(false);
      const store = JSON.parse(localStorage.getItem("storeUser") || "");
      setDateFerragem(start);

      return schedule
        .getScheduleCalendarV2(store?.value, "FERRAGEM", supplierIds, start, end)
        .then((response) => {
          const data = response.data?.data || [];
          updateDataFerragem(data);
          setLoadingFerragem(false);
          return data;
        })
        .catch(() => {
          updateDataFerragem([]);
          setLoadingFerragem(false);
          return [];
        });
    },
    [updateDataFerragem]
  );

  const getScheduleById = useCallback(
    async (id: number) => {
      setLoadingDrawer(true);
      setFirstData(false);

      schedule
        .getScheduleCalendarById(id)
        .then((response) => {
          setScheduleSelect(response.data?.data);
          setLoadingDrawer(false);
        })
        .catch(() => {
          setLoadingDrawer(false);
        });
    },
    [setScheduleSelect, setLoadingDrawer]
  );

  const getScheduleAvaliableDateById = useCallback(
    async (id: number) => {
      setLoadingModal(true);
      setFirstData(false);

      schedule
        .getScheduleDateAvaliableById(id)
        .then((response) => {
          updateDateAvaliable(response.data?.data);
          setLoadingModal(false);
        })
        .catch(() => {
          setLoadingModal(false);
        });
    },
    [updateDateAvaliable]
  );

  const saveReSchedulePatch = useCallback(async () => {
    setFirstData(false);
    const transformedArray = datesSchedulesModify.map((item, index) => ({
      id: item.id,
      schedulingQuantity: item.schedulingQuantity || 0,
    }));

    const obj = {
      schedulings: transformedArray,
    };

    schedule
      .saveReSchedulePatch(obj)
      .then((response) => {
        toast({
          title: "Salvo com Sucesso.",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      })
      .catch(() => {
        toast({
          title: "Error ao Salvar.",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  }, [datesSchedulesModify, toast]);

  const confirmReSchedule = useCallback(
    async (obj: any, id: any) => {
      setLoading(true);
      setFirstData(false);

      schedule
        .confirmReSchedule(obj, id)
        .then((response) => {
          var today = new Date(dateChaparia);
          getDataChaparia(
            formatDateUs(
              new Date(today.getFullYear(), today.getMonth() + 1, 1)
            ),
            formatDateUs(new Date(today.getFullYear(), today.getMonth() + 2, 0))
          );
          getDataFerragem(
            formatDateUs(
              new Date(today.getFullYear(), today.getMonth() + 1, 1)
            ),
            formatDateUs(new Date(today.getFullYear(), today.getMonth() + 2, 0))
          );
          toast({
            title: "Agendamento confirmado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao Salvar.",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [dateChaparia, getDataChaparia, getDataFerragem, toast]
  );

  const deleteData = useCallback(async (id: number) => {
    setLoading(true);
    setFirstData(false);
    let newParams = {};

    inventory
      .deleteInventory(id)
      .then((response) => {
        // getData();
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleUpdateWanted = useCallback(
    async (index: number, wanted: number | string) => {
      const purchase = scheduleSelect.filter((x) => x.id === Number(index));
      const ind = scheduleSelect.findIndex((x) => x.id === Number(index));
      let purchases = [...scheduleSelect];
      if (purchase[0]?.schedulingQuantity) {
        // verifica se a propriedade existe
        purchase[0] = {
          ...purchase[0],
          schedulingQuantity: wanted,
        };
      }

      purchases = [...purchases]; // important to create a copy, otherwise you'll modify state outside of setState call
      purchases[ind] = purchase[0];
      const newData = purchases;
      setScheduleSelect((draft) => {
        return draft.filter((item) => item.status === 99).concat(newData);
      });

      updateDatesSchedulesModify((prevArray) => {
        debugger;
        const objectIndex = prevArray.findIndex(
          (obj) => obj.id === purchase[0].id
        );
        if (objectIndex !== -1) {
          // If the object exists, replace it in the array
          const updatedArray = [...prevArray];
          updatedArray[objectIndex] = purchase[0];
          return updatedArray;
        } else {
          // If the object does not exist, add it to the array
          return [...prevArray, purchase[0]];
        }
      });

      // setLoading(false)
    },
    [scheduleSelect, setScheduleSelect, updateDatesSchedulesModify]
  );

  const formatDateWithOneDayMore = (dateString: string | number | Date) => {
    // Convertendo a string para um objeto Date
    const originalDate = new Date(dateString);

    // Adicionando um dia à data
    const modifiedDate = addDays(originalDate, 1);

    // Formatando a data modificada
    const formattedDate = format(modifiedDate, "dd/MM/yyyy");

    return formattedDate;
  };

  const downloadExport = useCallback(
    async (initDate: any, endDate: any, sector: any, supplierIds: number[] = []) => {
      
      Swal.fire({
        title: "Exportar dados!",
        html: "Aguarde um momento<b></b>.",
        timerProgressBar: true,
        timer: 99999,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      schedule
        .getScheduleDashboarExportV2(valueStore?.value, sector, supplierIds, initDate, endDate)
        .then((response) => {
          fileDownload(
            response.data,
            filename +
              "-" +
              sector +
              " - " +
              formatDateWithOneDayMore(initDate) +
              "_a_" +
              formatDateWithOneDayMore(endDate) +
              ".csv"
          );
          Swal.close();
        })
        .catch((error: any) => {
          const statusCode = error.response.status;
          if (statusCode === 404) {
            ShowErrorNotFound();
          }
          Swal.close();

          setLoading(false);
        });
    },
    []
  );

  return (
    <ScheduleContext.Provider
      value={{
        loading,
        dataChaparia,
        dataFerragem,
        isFirstData,
        headers,
        scheduleSelect: parseScheduleDrawer(scheduleSelect),
        datesAvaliable,
        idSelectDate,
        loadingDrawer,
        loadingModal,
        datesSchedulesModify,
        loadingFerragem,
        loadingChaparia,
        dateChaparia,
        dateFerragem,
        handleUpdateWanted,
        setSelectIdDate,
        getScheduleAvaliableDateById,
        getScheduleById,
        getDataChaparia,
        getDataFerragem,
        deleteData,
        confirmReSchedule,
        saveReSchedulePatch,
        downloadExport,
        setScheduleSelect,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};

export default ScheduleProvider;
export const ScheduleContext = createContext<IScheduleContext>(
  {} as IScheduleContext
);
